/*******************************************************************************
* Project: J-SIPHE
* Summary:
*    Define Safe Html Pipe
* History:
*    NghiaNX            2021/05/09    Create
******************************************************************************/
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
    constructor(private sanitized: DomSanitizer) {}
    transform(val: any) {
        return this.sanitized.bypassSecurityTrustHtml(val);
    }
}
